import {createAsyncThunk} from '@reduxjs/toolkit'
import {
  FetchPaymentCategoryByIdRequest,
  UpdatePaymentCategoryRequest,
  FetchPaymentCategoriesRequest,
  CreatePaymentCategoryRequest,
  DeletePaymentCategoryRequest,
  SuspendPaymentCategoryRequest,
  ActivatePaymentCategoryRequest,
  FetchAllPaymentCategoriesRequest,
  GetCategoriesForClassRequest,
  GetFeeForCategoryAndClassRequest,
  UpdateClassFeeRequest,
  GetCategoriesForClassResponse,
  GetFeeForCategoryAndClassResponse,
  UpdateClassFeeResponse,
} from './types'
import {AxiosError} from 'axios'
import {ResponseError} from '../commonTypes'
import {PaymentCategory} from '../../../models'
import axios from 'axios'
import {
  fetchPaymentCategoriesUrl,
  fetchPaymentCategoryByIdUrl,
  createPaymentCategoryUrl,
  updatePaymentCategoryUrl,
  deletePaymentCategoryUrl,
  suspendPaymentCategoryUrl,
  activatePaymentCategoryUrl,
  fetchAllPaymentCategoriesUrl,
  getCategoriesForClassUrl,
  getFeeForCategoryAndClassUrl,
  updateClassFeeUrl,
} from '../../api'

export const fetchPaymentCategories = createAsyncThunk(
  'paymentCategory/fetch',
  async (payload: FetchPaymentCategoriesRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${fetchPaymentCategoriesUrl}?sortField=${payload.sortField}&sortOrder=${
          payload.sortOrder
        }&pageNumber=${payload.pageNumber}&pageCount=${payload.pageCount}${
          payload.search && payload.search.trim() !== '' ? '&search=' + payload.search.trim() : ''
        }`
      )
      const {paymentCategories, totalPages, total} = res.data
      return {
        paymentCategories,
        totalPages,
        total,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchAllPaymentCategories = createAsyncThunk(
  'paymentCategory/fetchAll',
  async (payload: FetchAllPaymentCategoriesRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${fetchAllPaymentCategoriesUrl}`
      )
      const {paymentCategories} = res.data
      return {
        paymentCategories,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchPaymentCategoryById = createAsyncThunk(
  'paymentCategory/fetchById',
  async (payload: FetchPaymentCategoryByIdRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(`${fetchPaymentCategoryByIdUrl}/${payload.id}`)
      const {paymentCategory} = res.data
      return {
        paymentCategory,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const createPaymentCategory = createAsyncThunk(
  'paymentCategory/create',
  async (payload: CreatePaymentCategoryRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(createPaymentCategoryUrl, payload)
      const {paymentCategory} = res.data
      return {
        paymentCategory,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const updatePaymentCategory = createAsyncThunk(
  'paymentCategory/update',
  async (payload: UpdatePaymentCategoryRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(updatePaymentCategoryUrl, payload)
      const {paymentCategory} = res.data
      return {
        paymentCategory,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const deletePaymentCategory = createAsyncThunk(
  'paymentCategory/delete',
  async (payload: DeletePaymentCategoryRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(deletePaymentCategoryUrl, payload)
      const {paymentCategory} = res.data
      return {
        paymentCategory,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const suspendPaymentCategory = createAsyncThunk(
  'paymentCategory/suspend',
  async (payload: SuspendPaymentCategoryRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(suspendPaymentCategoryUrl, payload)
      const {paymentCategory} = res.data
      return {
        paymentCategory,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const activatePaymentCategory = createAsyncThunk(
  'paymentCategory/activate',
  async (payload: ActivatePaymentCategoryRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(activatePaymentCategoryUrl, payload)
      const {paymentCategory} = res.data
      return {
        paymentCategory,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

// Get categories with fees for a specific class
export const getCategoriesForClass = createAsyncThunk(
  'paymentCategory/getCategoriesForClass',
  async (payload: GetCategoriesForClassRequest, {rejectWithValue}) => {
    try {
      const url = `${getCategoriesForClassUrl}/${payload.classroomId}${
        payload.academicYear ? `?academicYear=${payload.academicYear}` : ''
      }`
      const res = await axios.get(url)
      const {categories} = res.data
      return {
        categories,
        success: true,
      } as GetCategoriesForClassResponse
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data?.fr || err.response?.data?.message || 'Error fetching categories'
      return rejectWithValue({
        success: false,
        error: message,
      })
    }
  }
)

// Get specific fee for category + class
export const getFeeForCategoryAndClass = createAsyncThunk(
  'paymentCategory/getFeeForCategoryAndClass',
  async (payload: GetFeeForCategoryAndClassRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${getFeeForCategoryAndClassUrl}/${payload.categoryId}/fee-for-class/${payload.classroomId}`
      )
      const {category, classroom, fee} = res.data
      return {
        category,
        classroom,
        fee,
        success: true,
      } as GetFeeForCategoryAndClassResponse
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data?.fr || err.response?.data?.message || 'Error fetching fee'
      return rejectWithValue({
        success: false,
        error: message,
      })
    }
  }
)

// Update single class fee
export const updateClassFee = createAsyncThunk(
  'paymentCategory/updateClassFee',
  async (payload: UpdateClassFeeRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(
        `${updateClassFeeUrl}/${payload.categoryId}/update-class-fee`,
        {
          classroom: payload.classroom,
          amount: payload.amount,
          currency: payload.currency || 'TND',
          notes: payload.notes,
          academicYear: payload.academicYear,
        }
      )
      const {paymentCategory} = res.data
      return {
        paymentCategory,
        success: true,
      } as UpdateClassFeeResponse
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data?.fr || err.response?.data?.message || 'Error updating fee'
      return rejectWithValue({
        success: false,
        error: message,
      })
    }
  }
)

